import DatePicker from "ant-design-vue/lib/date-picker"; // 加载 JS
import "ant-design-vue/lib/date-picker/style/css"; // 加载 CSS
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import "moment/locale/zh-cn";
import Vue from "vue";
import moment from "moment/moment";
Vue.use(DatePicker);
const datePickerMixin = {
  name: "sk-date-picker",
  props: {
    field: {},
    fieldValue: null,
    fieldResult: {},
    checkFlag: false
  },
  data() {
    return {
      locale,
      fieldObj: {},
      timeValue: this.fieldValue || null,
      isopen: false,
      dateType: "date"
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      this.$emit("update:fieldValue", {
        VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
        fieldName: this.fieldObj.fieldName,
        value: this.timeValue
      });
      this.$emit("update:fieldResult", this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = ((window.$sk && window.$sk.$t) || function(){return '请选择';})('field.please_select');
    }
    this.fieldObj = new window.$sk.DateTime(this.field);
    //更改showTime 对象 hack
    let format = undefined;
    if (this.fieldObj.showTime && this.fieldObj.showTime["nzFormat"]) {
      format = this.fieldObj.showTime["nzFormat"];
    }
    switch (this.field.accuracy || this.field.dateLimitType) {
      case "MINUTE":
        this.dateType = "date";
        format = "HH:mm";
        this.fieldObj.showTime.format = format;
        this.fieldObj.format = "YYYY-MM-DD HH:mm";
        this.fieldObj.valueformat = this.field.dateLimitType
          ? "YYYY-MM-DD HH:mm:ss"
          : "YYYY-MM-DD HH:mm";
        break;
      case "HOUR":
        this.dateType = "date";
        format = "HH";
        this.fieldObj.showTime.format = format;
        this.fieldObj.format = "YYYY-MM-DD HH";
        this.fieldObj.valueformat = this.field.dateLimitType
          ? "YYYY-MM-DD HH:mm:ss"
          : "YYYY-MM-DD HH";
        break;
      case "DAY":
        this.dateType = "date";
        this.fieldObj.showTime = undefined;
        this.fieldObj.format = "YYYY-MM-DD";
        this.fieldObj.valueformat = this.field.dateLimitType
          ? "YYYY-MM-DD HH:mm:ss"
          : "YYYY-MM-DD";
        break;
      case "MONTH":
        this.dateType = "month";
        this.fieldObj.format = "YYYY-MM";
        this.fieldObj.valueformat = this.field.dateLimitType
          ? "YYYY-MM-DD HH:mm:ss"
          : "YYYY-MM";
        break;
      case "YEAR":
        this.dateType = "year";
        this.fieldObj.format = "YYYY";
        this.fieldObj.valueformat = this.field.dateLimitType
          ? "YYYY-MM-DD HH:mm:ss"
          : "YYYY";
        break;
    }
    if (this.timeValue) this.fieldObj.setValue(this.timeValue);
  },
  methods: {
    handleChange() {
      this.fieldObj.setValue(this.timeValue);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: this.timeValue,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    handleChange2() {
      this.timeValue = null;
    },
    handleOpenChange(val) {
      this.isopen = val;
    },
    handlePanelChange(val) {
      this.timeValue = this.field.dateLimitType
        ? val
        : moment(val).format(this.fieldObj.format);
      this.fieldObj.setValue(this.timeValue);
      this.isopen = false;
    }
  }
};
export default datePickerMixin;
